import { render, staticRenderFns } from "./EmojiItem.vue?vue&type=template&id=6ddd033a&scoped=true&"
import script from "./EmojiItem.vue?vue&type=script&lang=js&"
export * from "./EmojiItem.vue?vue&type=script&lang=js&"
import style0 from "./EmojiItem.vue?vue&type=style&index=0&id=6ddd033a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd033a",
  null
  
)

export default component.exports